"use strict";
export var ProtocolItems = /* @__PURE__ */ ((ProtocolItems2) => {
  ProtocolItems2["V2"] = "V2";
  ProtocolItems2["V3"] = "V3";
  ProtocolItems2["V4"] = "V4";
  ProtocolItems2["UNISWAPX"] = "UNISWAPX";
  ProtocolItems2["UNISWAPX_V2"] = "UNISWAPX_V2";
  ProtocolItems2["UNISWAPX_V3"] = "UNISWAPX_V3";
  return ProtocolItems2;
})(ProtocolItems || {});
